import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './StudentIDCard.css';

function StudentIDCard({ student, schoolName, onClose, onPrint }) {
  const [loading, setLoading] = useState(false);

  const handlePrint = () => {
    setLoading(true);
    setTimeout(() => {
      window.print();
      setLoading(false);
      if (onPrint) onPrint();
    }, 100);
  };

  if (!student) return null;

  return (
    <div className="student-id-modal-overlay" onClick={onClose}>
      <div className="student-id-modal" onClick={(e) => e.stopPropagation()}>
        <div className="student-id-header">
          <h2>Student ID Card</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="id-card-preview" id="id-card-print">
          <div className="id-card-front">
            <div className="id-card-header">
              <div className="school-name">{schoolName || 'KN Education Portal'}</div>
              <div className="card-title">STUDENT IDENTIFICATION</div>
            </div>

            <div className="id-card-body">
              <div className="student-photo">
                {student.photoURL ? (
                  <img src={student.photoURL} alt={`${student.firstName} ${student.lastName}`} />
                ) : (
                  <div className="photo-placeholder">
                    <span>{student.firstName?.[0]}{student.lastName?.[0]}</span>
                  </div>
                )}
              </div>

              <div className="student-info">
                <div className="info-row">
                  <span className="label">NAME</span>
                  <span className="value">{student.firstName} {student.lastName}</span>
                </div>
                <div className="info-row">
                  <span className="label">ID</span>
                  <span className="value">{student.studentId}</span>
                </div>
                {student.email && (
                  <div className="info-row">
                    <span className="label">EMAIL</span>
                    <span className="value">{student.email}</span>
                  </div>
                )}
                <div className="info-row">
                  <span className="label">GRADE</span>
                  <span className="value">{student.grade || 'N/A'}</span>
                </div>
                <div className="info-row">
                  <span className="label">CLASS</span>
                  <span className="value">{student.className || 'N/A'}</span>
                </div>
              </div>

              <div className="qr-code-section">
                <QRCodeSVG
                  value={student.studentId}
                  size={100}
                  level="H"
                  includeMargin={false}
                />
                <div className="qr-label">SCAN</div>
              </div>
            </div>

            <div className="id-card-footer">
              <div className="issue-date">
                Issued: {new Date().toLocaleDateString()}
              </div>
              <div className="valid-until">
                Valid: {new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toLocaleDateString()}
              </div>
            </div>
          </div>
        </div>

        <div className="id-card-actions">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="print-button" onClick={handlePrint} disabled={loading}>
            {loading ? 'Printing...' : 'Print ID Card'}
          </button>
        </div>

        <div className="print-instructions">
          <p>💡 For best results, print on card stock paper at actual size (3.375" × 2.125" credit card size)</p>
        </div>
      </div>
    </div>
  );
}

export default StudentIDCard;
